import React from 'react';
import UsersTable from '../../shared/Tables/UsersTable';

class UsersInvoiceDetails extends React.Component {

	render() {
		// console.log('UsersInvoiceDetails: render');
		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Utilisateurs - Facturation</h5>
				<div className="card">
					<div className="card-header">
						<i className="fa fa-th-large"></i>
						Utilisateurs
					</div>

					<div className="card-block">
					<UsersTable type="1"/>
					</div>
				</div>
			</div>
			</div>
		);
	}

}

export default UsersInvoiceDetails;